<template>
    <div class="mbody">
        <h1 style="justify-content: center;display: flex;">Coal Mine</h1>

        <hr class="rounded">
        <div style="justify-content: center;display: flex;" v-show="Object.keys($store.state.mine_manager.mine).length == 0">&lt;
            Mine is empty &gt;</div>

        <CoalMineItemVue v-for="(wrkrv, wrkk) in $store.state.mine_manager.mine" :key="wrkrv"
            v-bind:id="('minele-' + wrkrv.nft.get_id())" :mineItem="wrkrv" :wrkk="wrkk">

        </CoalMineItemVue>
    </div>
</template>

<script>

import ENUMS from '../Enums';
import CoalMineItemVue from './CoalMineItem.vue';
import { get_nft_strength_from_hash } from '@/utility'

export default {
    name: ENUMS.VIEWS.MINE
    , data() {
        return {
            ENUMS: ENUMS

        }
    }
    , mounted() {

    }
    , methods: {
        get_nft_strength_from_hash: get_nft_strength_from_hash
    }, components: {
        CoalMineItemVue
    }
}

</script>

